import { z } from 'zod'

import { SynopticCategorySchema, SynopticSchema, SynopticTypeSchema } from '@shared/schema/synoptic.base.schema'
import { numberOrStringToNumberSchema } from '@shared/schema/utils'

// Filtres optionnels : on peut lister tous les synoptics ou ne récupérer qu'un type / une catégorie
// (ex. tous les schémas CTA, ou tous les composants custom).
// `unlocated` restreint aux synoptics sans site : les templates et composants réutilisables, par
// opposition aux synoptics générés pour un site donné, qui relèvent de la vue technique de leur site
// et n'ont rien à faire dans une liste globale.
export const GetSynopticsQueryStringSchema = z
  .object({
    type: SynopticTypeSchema.optional(),
    category: SynopticCategorySchema.optional(),
    unlocated: z.enum(['true', 'false']).optional(),
    // Restreint à un site : la réponse est alors cloisonnée par société + user_site, et porte les
    // noms de site / bâtiment / étage résolus à plat pour l'affichage.
    siteId: numberOrStringToNumberSchema.optional(),
  })
  .optional()

// Les noms de localisation ne sont renvoyés que par la variante scopée (jointures sur site /
// location) : nuls ailleurs, ce qui laisse un seul type de réponse pour l'endpoint.
export const GetSynopticsResponseSchema = SynopticSchema.extend({
  siteName: z.string().nullable(),
  buildingName: z.string().nullable(),
  floorName: z.string().nullable(),
}).array()

export type GetSynopticsQueryString = z.infer<typeof GetSynopticsQueryStringSchema>
export type GetSynopticsResponse = z.infer<typeof GetSynopticsResponseSchema>
